export const userData = {
  nameUser: "Samuel Leão",
  githubUser: "Pedrolbsousa",
  linkedinUser: "pedro-lima-a425b158",
  whatsappNumber: "+5561993960268",
  email: "pedro.l.b.sousa",
};
